import { useContent } from 'hooks/useContent';
import type { FC } from 'react'

export const MainFooter: FC = () => {
  const { content } = useContent();

  return (
    <div className="footer">
      <section className="section-regular footer">
        <div className="container-large">
          <div className="w-layout-grid footer-grid">
            <div id="w-node-_8d20d751-ba12-8f08-e28f-84feb73dd88b-b73dd887" className="footer-column column-1">
              <a href={content.footerMenu.logoLink} aria-current="page" className="footer-logo w-inline-block w--current">
                <img src="/images/start-in-turkiye-white.svg" loading="lazy" width="122" sizes="240px" alt=""  className="footer-absolute-image" /></a>
                <div className="footer-row">
                {/* <a href="https://www.invest.gov.tr/en/pages/contact-us.aspx" target='_blank' className="footer-sub-link main right w-inline-block">
                  <div className="footer-heading right-aligned">FOLLOW US  <span className="text-span-2"></span></div>
                </a> */}
                <div className="footer-social-links">
                  <a href={content.socialMedia.facebook} target='_blank' className="footer-social-link w-inline-block">
                    <div className="footer-social"></div>
                  </a>
                  <a href={content.socialMedia.x} target='_blank' className="footer-social-link w-inline-block">
                    <div className="footer-social"></div>
                  </a>
                  <a href={content.socialMedia.instagram} target='_blank' className="footer-social-link w-inline-block">
                    <div className="footer-social"></div>
                  </a>
                  <a href={content.socialMedia.linkedin} target='_blank' className="footer-social-link w-inline-block">
                    <div className="footer-social"></div>
                  </a>
                  <a href={content.socialMedia.youtube} target='_blank' className="footer-social-link w-inline-block">
                    <div className="footer-social"></div>
                  </a>
                </div>
              </div>
            </div>
           
            <div id="w-node-_8d20d751-ba12-8f08-e28f-84feb73dd8c8-b73dd887" className="footer-details">
             
              <a href="https://fdistrategy.invest.gov.tr" target='_blank' className="footer-sub-link main right w-inline-block">
                <div className="footer-heading right-aligned">FDI STRATEGY  <span className="text-span-2"></span></div>
              </a>
              <a href="https://fdiglossary.invest.gov.tr" target='_blank' className="footer-sub-link main right w-inline-block">
                <div className="footer-heading right-aligned">FDI GLOSSARY  <span className="text-span-2"></span></div>
              </a>
              <div className="wrap-v-xsmall">
                <div className="footer-bottom-logo"><img src="/images/invest-in-wide.svg" loading="lazy" alt="" className="logo-visual _50" /></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-legal-dark">
        <div className="container-large-8">
          <div className="footer-legal-wrap-2">
            <div className="legal-links-small col1">
              {/* <a href="#" className="footer-legal-link-dark">Privacy Policy</a> */}
              {/* <a href="#" className="footer-legal-link-dark">Terms of Service</a> */}
            </div>
            <div id="w-node-_8d20d751-ba12-8f08-e28f-84feb73dd8ef-b73dd887" className="legal-links-small col2">
              <a href="https://invest.gov.tr" className="footer-image-link w-inline-block"><img src="/images/fullwhite-wide.svg" loading="lazy" alt="" /></a>
            </div>
            <div id="w-node-_8d20d751-ba12-8f08-e28f-84feb73dd8f2-b73dd887" className="legal-links-small col3">
              {/* <a href="#" className="footer-legal-link-dark">Contact</a> */}
              {/* <a href="#" className="footer-legal-link-dark">Cookies Settings</a> */}
              <a id="w-node-_8d20d751-ba12-8f08-e28f-84feb73dd8f7-b73dd887" href="#" className="footer-scroll-link">Back to Top ↑</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
